import {
  type PathLookupGraphPreset,
  type PathLookupGraphSettings,
  type TopologyGraphPreset,
  type TopologyGraphSettings,
  isTopologyGraphSettings,
  pick,
} from '@ipfabric/utils';
import type { Reduced } from 'utils/types/Reduced';

export const extractPresetSettings = (
  settings: TopologyGraphSettings | PathLookupGraphSettings,
):
  | Reduced<TopologyGraphPreset, TopologyGraphSettings>
  | Reduced<PathLookupGraphPreset, PathLookupGraphSettings> =>
  isTopologyGraphSettings(settings)
    ? pick(['edges', 'hiddenDeviceTypes'])(settings)
    : pick(['edges', 'pathLookup'])(settings);
